import { render, staticRenderFns } from "./UploadIosApp.vue?vue&type=template&id=99a2dd1a&scoped=true&"
import script from "./UploadIosApp.vue?vue&type=script&lang=js&"
export * from "./UploadIosApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a2dd1a",
  null
  
)

export default component.exports